export type Environments = 'development' | 'staging' | 'prod';

export const DEPLOYED_ENVIRONMENT = process.env.DEPLOYED_ENVIRONMENT as Environments;
